import React, { Component } from "react";
import styles from "./logisticsList.module.scss";

import { NavLink } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { withAuth } from "../../../shared/containers/containerAuth";

const items = [
  {
    title: "Контрольные точки",
    url: "/logistic/controlPoints",
    permissions: 26001,
  },
  {
    title: "Маршруты",
    url: "/logistic/routes",
    permissions: 27001,
  },
  {
    title: "Рейсы",
    url: "/logistic/trips",
    permissions: 29004,
  },
  {
    title: "Отчеты",
    url: "/logistic/reports",
    permissions: 53001,
  },
];

class LogisticsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pathname: window.location.pathname,
    };
  }

  render() {
    const { data } = this.props;

    return items.map((item) => {
      const { pathname } = this.state;

      if (item.permissions !== null && !data.permissions.includes(item.permissions)) {
        return null;
      }

      return (
        <NavLink key={uuidv4()} to={item.url}>
          <div
            className={styles.controlItemContainer}
            onClick={() => {
              this.setState({ pathname: item.url });
            }}
          >
            <div className={pathname.includes(item.url) ? styles.controlItemSelect : styles.controlItem}>{item.title}</div>
          </div>
        </NavLink>
      );
    });
  }
}

export default withAuth(React.memo(LogisticsList));
